import murmur from 'murmurhash-js'

import { dataLayerPush } from 'client/contexts/Tracking'
import { trackingRequest as kafkaSend } from 'client/contexts/Tracking/requests'
import { getSessionId } from 'client/contexts/Tracking/utils'
import { MISSING_EXPERIMENT } from 'src/context/experiment/constants'
import { Experiment } from 'src/types/experiment'

import { ReportExperimentType } from './types'
import { ORIGIN_DIRECT } from 'client/contexts/Tracking/constants'
import { DEFAULT_AFFILIATE_ID } from 'src/pages/_middleware/defaultAffiliate'

export function validateExperiment(
  experiment: Experiment | typeof MISSING_EXPERIMENT | null,
  experimentKey: string
) {
  if (!experiment) {
    return false
  }

  if (experiment === MISSING_EXPERIMENT) {
    return false
  }

  if (experiment.key !== experimentKey) {
    return false
  }

  return experiment
}

export function reportToKafka(kafkaEventPayload: ReportExperimentType) {
  const {
    affiliate = DEFAULT_AFFILIATE_ID,
    experiment,
    market,
    language,
    device,
    ip,
    isBot,
    pageId,
    isLogged,
    customer,
  } = kafkaEventPayload
  const eventName = 'experiment'
  const eventType = 'experiment'

  if (!experiment || experiment === MISSING_EXPERIMENT) return

  const timestamp = Date.now()

  const eventPayload = {
    hsl: murmur(`${eventName}${timestamp}${eventType}`, 87) || null,
    level: 'info',
    event_sub_type: null,
    ip,
    is_bot: isBot,
    created_at: timestamp,
    screen: `${window.screen.width}x${window.screen.height}`,
    session_id: getSessionId(),
    language: language || null,
    source: 'web',
    market,
    event_type: eventType || null,
    user_id: customer?.userId || null,
    scope: 'tracking',
    event_name: eventName,
    device,
    user_agent: navigator.userAgent,
    payload: {
      affiliate,
      page: pageId,
      experiments: [{ experiment_id: experiment.key, experiment_variant: experiment.variant }],
      is_logged: isLogged,
      origin: document.referrer || ORIGIN_DIRECT,
    },
  }

  kafkaSend(eventPayload)
}

export function reportToDataLayer(dataLayerEventPayload: ReportExperimentType) {
  const { experiment } = dataLayerEventPayload
  const payload = []
  if (experiment && experiment !== MISSING_EXPERIMENT) {
    payload.push({
      event: 'sflExperiment',
      data: {
        expId: experiment.id,
        expVar: experiment.variant,
      },
    })
  }

  dataLayerPush(payload)
}

export function reportExperiment(experimentPayload: ReportExperimentType) {
  reportToDataLayer(experimentPayload)
  reportToKafka(experimentPayload)
}
